import { TextField, type TextFieldProps } from '@mui/material';
import { Control, Controller, FieldPathByValue, FieldValues } from 'react-hook-form';

type FormTextFieldProps<T extends FieldValues> = Omit<
  TextFieldProps,
  'error' | 'label' | 'name' | 'onBlur' | 'onChange' | 'required' | 'value'
> & {
  name: FieldPathByValue<T, string | undefined>;
  control: Control<T>;
  label?: string;
  required?: boolean;
  requiredMessage?: string;
};

export function FormTextField<T extends FieldValues>({
  name,
  control,
  label,
  required = false,
  requiredMessage,
  helperText,
  ...props
}: FormTextFieldProps<T>) {
  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: required ? requiredMessage || true : false }}
      render={({ field, fieldState }) => (
        <TextField
          {...props}
          {...field}
          label={label ?? field.name}
          required={required}
          error={!!fieldState.error}
          helperText={fieldState.error?.message ?? helperText}
        />
      )}
    />
  );
}
